import { render, staticRenderFns } from "./zhiweiMb.vue?vue&type=template&id=912a7460&scoped=true&"
import script from "./zhiweiMb.vue?vue&type=script&lang=js&"
export * from "./zhiweiMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a7460",
  null
  
)

export default component.exports